import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SectorAirGroupComponent } from './sector-air-group.component';
import {
    FieldDescriptionModule
} from "../../../../../../../module/formbuilder/fields/form-field/components/field-description/field-description.module";
import {ClickOutsideModule} from "../../../../../../../ui_clickOutside/clickOutside.module";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {
    IconNameToDefinitionModule
} from "../../../../../../../pipes/icon-name-to-definition/icon-name-to-definition.module";


@NgModule({
    imports: [
        CommonModule,
        ClickOutsideModule,
        FieldDescriptionModule,
        FontAwesomeModule,
        IconNameToDefinitionModule
    ],
    exports: [
        SectorAirGroupComponent
    ],
    declarations: [
        SectorAirGroupComponent,
    ]
})
export class SectorAirGroupModule { }
